import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import { closeTabId, multiPanelAtom, panelInitDataAtom } from '@/state/atom/panelAtom';
import { triggerReloadTab, closePanelTabSelector, setPanelSelector } from '@/state/selector/panelSelector';
import { markSelfUpdatingMainLanguage } from '@/component/common/layout/header/handler/HeaderTopHandler';
import { isEqual } from 'lodash';
import { useSnackbar } from 'notistack';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';

import './OrganizationProfile.css';
import { FormProvider, useForm } from 'react-hook-form';
import {
    Button,
    MenuItem,
    TextField,
    Chip,
    Tooltip,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';
import { yupResolver } from '@hookform/resolvers';
import UpdateCorporationSchema from '@/schema/UpdateCorporationSchema';

import CropImage from '@/component/common/form/crop-image/index';
import FormInput from '@/component/common/form/input';
import PhoneInput from 'react-phone-input-2';
import ErrorHelper from '@/component/common/ErrorHelper';
import LoadingPanel from '@/component/common/LoadingPanel';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';

import { 
    getInitCorporationAndListUser, 
    handleSubmitEditCorporation, 
    onLogoFileChange, 
    handleCancelTab,
    handleCloseTab,
    checkModelUnsupport,
    handleAddNew,
    editModelSetting
} from '@/component/system/handler/OrganizationProfileHandler';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import OverFlowTooltipWithCustomCss from '../common/OverFlowTooltipWithCustomCss';
import OverflowTooltipContent from '@/component/common/OverflowTooltipContent';
import {
    handleOnBlurKBoardSystemPrompt,
    handleRemoveKBoardSystemPrompt
} from '@/component/common/handler/KBoardSystemPromptHandler';
import {
    validateTextField,
    handleOnBlurEditSystemPromptModelSetting,
    validateModelError,
    isExistPromptError,
    onDeleteAddModelSetting,
    onDeleteModelSetting,
    handleModelChange
} from '../productManagement/handler/VersionListHandler';
import { getProductByIdAPI } from '@/service/productManagementService';
import IPRestrictionSetting from '@/component/system/components/IPRestrictionSetting';
import {
    onChangeUsingIpAddressRestrict,
    onChangeIpAddressRange,
    changeIpAddressRange
} from '@/component/project/handler/ProjectProfileManagementHandler';
import { openPromptTicketPanel } from '@/component/chatAI/handler/ChatAIHandler';
import {
    projectInuseDetailAtom,
    projectListInCorporationAtom,
    projectListInCorporationByUserIdAtom
} from '@/state/atom/projectAtom';
import MessageCode from '@/common/constant/MessageCode';

import PropTypes from 'prop-types';
import MultiAuthSetting from '@/component/system/components/MultiAuthSetting';
import AddModelSettingRow from './components/AddModelSettingRow';
import { v4 as uuidv4 } from 'uuid';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import useRevalidateOnTranslation from '@/hooks/useRevalidateOnTranslation';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

OrganizationProfile.propTypes = {
    API: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any
    
};
export default function OrganizationProfile(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const [initData, setInitData] = useState({});
    const [isAdminGuest, setIsAdminGuest] = useState(false);
    const [adminName, setAdminName] = useState('');
    const [adminMail, setAdminMail] = useState('');
    const [adminList, setAdminList] = useState([]);
    const [subDomain, setSubDomain] = useState('');
    const [usingChatAI, setUsingChatAI] = useState(false);
    const [lincenseKeyPermission, setLincenseKeyPermission] = useState(false);
    const [lincenseKey, setLincenseKey] = useState({
        value: '',
        error: ''
    });
    const [licenseKeyDefault, setLicenseKeyDefault] = useState('');

    const [usingAIAuto, setUsingAIAuto] = useState(false);
    const [usingSDAuto, setUsingSDAuto] = useState(false);
    const [usingTelephoneAgent, setUsingTelephoneAgent] = useState(false);
    const [usingFileTranslation, setUsingFileTranslation] = useState(false);
    const [usingKBoard, setUsingKBoard] = useState(false);
    const [usingMultiLanguage, setUsingMultiLanguage] = useState(false);
    // K-Board System Prompt (share link -> prompt name chip, max 1 prompt)
    const [kBoardSystemPromptLink, setKBoardSystemPromptLink] = useState('');
    const [kBoardPromptDetail, setKBoardPromptDetail] = useState({});
    const [errorKBoardSystemPrompt, setErrorKBoardSystemPrompt] = useState('');
    const [systemPrompt, setSystemPrompt] = useState({
        value: '',
        error: '',
        linkPrompt: '',
        isPromptValid: true
    });
    const [systemPromptDefault, setSystemPromptDefault] = useState({
        value: '',
        error: '',
        linkPrompt: '',
        isPromptValid: true
    });

    const [isChangeSystemPrompt, setIsChangeSystemPrompt] = useState(false);

    const [interatorSystemPrompt, setInteratorSystemPrompt] = useState({
        value: '',
        error: '',
        linkPrompt: ''
    });
    const [interatorSystemPromptDefault, setInteratorSystemPromptDefault] = useState({
        value: '',
        error: '',
        linkPrompt: ''
    });
    const [isChangeInteratorSystemPrompt, setIsChangeInteratorSystemPrompt] = useState(false);

    const [imagePreview, setImagePreview] = useState('');
    const [logoFileName, setLogoFileName] = useState('');
    const [oldLogoFileName, setOldLogoFileName] = useState('');
    const [inputImage, setInputImage] = useState('');
    const [errorImage, setErrorImage] = useState('');
    const [croppedImage, setCroppedImage] = useState(null);
    const [corporationPhone, setCorporationPhone] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [isShowPopUpCancel, setIsShowPopUpCancel] = useState(false);
    const [isShowPopUpCloseTab, setIsShowPopUpCloseTab] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);

    const [openCrop, setOpenCrop] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const reloadPanelChatbotSetting = useSetRecoilState(triggerReloadTab);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [enableOnChangeVectorData, setEnableOnChangeVectorData] = useState(true)
    const [usingIpAddressRestrict, setUsingIpAddressRestrict] = useState(false);
    const [usingMultiAuth, setUsingMultiAuth] = useState(false);
    const [ipAddressRange, setIpAddressRange] = useState();
    const [ipRestrictionError, setIPRestrictionError] = useState({})

    const { enqueueSnackbar } = useSnackbar();
    const cropShape = '';
    const aspect = 3 / 1;

    // common corporationDetail state
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    const [chatGPTModel, setChatGPTModel] = useState('');
    const [chatGPTModelList, setChatGPTModelList] = useState([]);
    const [knn, setKnn] = useState({
        value: '',
        error: ''
    });
    const [minScore, setMinScore] = useState({
        value: '',
        error: ''
    });

    const [chatGPTModelDefault, setChatGPTModelDefault] = useState('');
    const [knnDefault, setKnnDefault] = useState({
        value: '',
        error: ''
    });
    const [minScoreDefault, setMinScoreDefault] = useState({
        value: '',
        error: ''
    });

    const [isShowMsgSettingAI, setIsShowMsgSettingAI] = useState(false);
    const [isModelUnsupport, setIsModelUnsupport] = useState(false);
    const methods = useForm({
        mode: 'onBlur',
        resolver: yupResolver(UpdateCorporationSchema)
    });
    let addNewPanel = useSetRecoilState(setPanelSelector);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const setListProjectInCorp = useSetRecoilState(projectListInCorporationAtom);
    const setListProjectOfUser = useSetRecoilState(projectListInCorporationByUserIdAtom);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [inputSystemPrompt, setInputSystemPrompt] = useState('');
    const [inputInteratorSystemPrompt, setInputInteratorSystemPrompt] = useState('');

    const [modelSettingList, setModelSettingList] = useState([]);
    const [modelSettingListRoot, setModelSettingListRoot] = useState([]);
    const [modelSettingAddList, setModelSettingAddList] = useState([]);
    const [usingMCPServer, setUsingMCPServer] = useState(false);
    const [usingKibanaAnalysis, setUsingKibanaAnalysis] = useState(false);

    const { handleSubmit, errors, formState, getValues, setValue, reset, setError, register, clearErrors, unregister} = methods;
    // Rebuild error messages that are already shown once the translation dictionary loads.
    useRevalidateOnTranslation(errors, methods.trigger);

    const getInitCorpArgs = {
        API: props?.API,
        corporationId: corporationDetail.id,
        corporationDetailAtom: corporationDetail,
        panelId: props.panelId,
        tabId: props.tabId,
        setIsLoading,
        closePanelTab,
        setInitData,
        setIsAdminGuest,
        setAdminList,
        setAdminName,
        setAdminMail,
        setCorporationPhone,
        setSubDomain,
        setUsingChatAI,
        setImagePreview,
        setLogoFileName,
        setOldLogoFileName,
        register,
        setValue,
        setLincenseKeyPermission,
        setLincenseKey,
        setLicenseKeyDefault,
        setUsingAIAuto,
        setUsingSDAuto,
        setUsingTelephoneAgent,
        setUsingFileTranslation,
        setUsingKBoard,
        setUsingMultiLanguage,
        setSystemPrompt,
        setSystemPromptDefault,
        setChatGPTModel,
        setChatGPTModelList,
        setKnn,
        setMinScore,
        setChatGPTModelDefault,
        setKnnDefault,
        setMinScoreDefault,
        setInputSystemPrompt,
        setInteratorSystemPrompt,
        setInteratorSystemPromptDefault,
        setInputInteratorSystemPrompt,
        setIsModelUnsupport,

        setModelSettingList,
        setModelSettingAddList,
        setModelSettingListRoot,
        setUsingMCPServer,
        setUsingKibanaAnalysis,
        setKBoardSystemPromptLink,
        setKBoardPromptDetail,
        setErrorKBoardSystemPrompt
    }

    useEffect(() => {
        if (!Utils.isEmptyObject(corporationDetail)) {
            getInitCorporationAndListUser(getInitCorpArgs)
                .then(response => {
                    if(response) setIsLoading(false);
                })
                .catch(error => {
                    setIsLoading(false);
                    console.log('get initCorp error >>>', error);
                });
        }
    }, []);

    useEffect(() => {
        if (!Utils.isEmptyObject(corporationDetail)) {
            let limitValueOfCorporation = corporationDetail?.limitValue;

            if (
                limitValueOfCorporation?.usingChatAI == 1 &&
                limitValueOfCorporation?.vectorTicketDataStatus !== Constant.VECTOR_DATA_STATUS.DONE
            ) {
                setEnableOnChangeVectorData(false);
            } else {
                setEnableOnChangeVectorData(true);
            }

            const corporationSetting = Utils.convertJSONDataToObject(
                corporationDetail?.corporationSetting
            );
            if(!Utils.isEmptyObject(corporationSetting)){
                setUsingIpAddressRestrict(corporationSetting?.usingIpAddressRestrict);
                setIpAddressRange(corporationSetting?.ipAddressRange);
                setUsingMultiAuth(!!corporationSetting?.usingMultiAuth);
            }
        }
    }, [corporationDetail]);

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (formState.isDirty || croppedImage || isEdited) {
                setIsShowPopUpCloseTab(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'isEditedData',
            isEdited
        );
    }, [isEdited]);

    useEffect(() => {
        /**
         * restore corporation ip address range. when usingIpAddressRestrict = off
         */
        const corporationSetting = Utils.convertJSONDataToObject(
            corporationDetail?.corporationSetting
        );
        if (
            !Utils.isEmptyObject(corporationSetting) &&
            corporationSetting?.ipAddressRange &&
            !usingIpAddressRestrict
        ) {
            setIpAddressRange(corporationSetting?.ipAddressRange);
        }
    }, [usingIpAddressRestrict]);

    const onChangePhoneNumber = (phoneValue, country) => {
        setCorporationPhone(phoneValue);
        setIsEdited(true);
        if (phoneValue === country.dialCode) {
            setValue('telNumberCorporation', '');
        } else {
            clearErrors('telNumberCorporation');
            setValue('telNumberCorporation', phoneValue);
        }
    };

    const onBlurPhoneInput = (e, country) => {
        let phoneValue = e.target.value;
        phoneValue = phoneValue.substring(1);

        if (phoneValue === country.dialCode) {
            setValue('telNumberCorporation', '');
            if (!isAdminGuest) {
                setError(
                    'telNumberCorporation',
                    { type: 'manual', message: trI18n('COMMSG014') },
                    { shouldFocus: false }
                );
            }
        } else {
            setValue('telNumberCorporation', phoneValue);
            clearErrors('telNumberCorporation');
        }
    };

    const isDisableSubmitBtn  = () => {
        let isCorporationName = getValues('corporationName') ? true : false;
        let isSelectedAdmin = getValues('selectedAdmin') ? true : false;
        let isMailAdmin = getValues('mailAdmin') ? true : false;
        let isTelNumberCorporation = getValues('telNumberCorporation') ? true : false;
        let isLincenseKeyError = !Utils.isEmptyString(lincenseKey.error);
        let isChatGPTModelError = !Utils.isEmptyString(chatGPTModel.error);
        let isKnnValueError = !Utils.isEmptyString(knn.error);
        let isMinScoreError = !Utils.isEmptyString(minScore.error);
        let ipAddressValidation = true
        let isModelGptUnsupport = checkModelUnsupport(chatGPTModel, chatGPTModelList);
        let isExistPromptValid = isExistPromptError(modelSettingList, modelSettingAddList);
        let isExistModelError = validateModelError(modelSettingList, modelSettingAddList, chatGPTModelList);
        if (
            usingIpAddressRestrict &&
            !Utils.isEmptyObject(ipRestrictionError) &&
            ipRestrictionError
        )
            ipAddressValidation = false;

        if (
            isEdited &&
            isCorporationName &&
            isSelectedAdmin &&
            isMailAdmin &&
            Utils.isEmptyObject(errors) &&
            Utils.isEmptyString(errorImage) &&
            !isLincenseKeyError &&
            !isChatGPTModelError &&
            !isKnnValueError &&
            !isMinScoreError &&
            ipAddressValidation &&
            !isModelUnsupport &&
            !isModelGptUnsupport &&
            !isExistPromptValid &&
            !isExistModelError

        ) {
            if (isAdminGuest) {
                return false;
            } else if (!isAdminGuest && isTelNumberCorporation) {
                return false;
            }
        }

        return true;
    }

    const isEffectiveFileTranslationOff = corporationDetailData => {
        const limitValue = Utils.convertJSONDataToObject(corporationDetailData?.limitValue) || {};
        const fileTranslationOn = Number(limitValue?.fileTranslation) === Constant.STATUS_SERVICE_PERMISSION.ON ||
            limitValue?.fileTranslation === true;
        const usingFileTranslationOn = Number(limitValue?.usingFileTranslation) === Constant.STATUS_SERVICE_PERMISSION.ON ||
            limitValue?.usingFileTranslation === true;

        return !fileTranslationOn || !usingFileTranslationOn;
    };

    const resetProjectFileTranslationSetting = project => {
        if (
            Utils.isEmptyObject(project) ||
            project.type === Constant.PROJECT_TYPE.BASE ||
            project.projectInvite
        ) {
            return project;
        }

        const projectSetting = Utils.convertJSONDataToObject(project.projectSetting) || {};
        if (projectSetting.usingFileTranslation !== true) return project;

        return {
            ...project,
            projectSetting: JSON.stringify({
                ...projectSetting,
                usingFileTranslation: false
            })
        };
    };

    const syncProjectFileTranslationSettingAfterOrgSave = corporationDetailData => {
        if (!isEffectiveFileTranslationOff(corporationDetailData)) return;

        setProjectInuseDetail(prev => resetProjectFileTranslationSetting(prev));
        setListProjectInCorp(prev => Array.isArray(prev)
            ? prev.map(project => resetProjectFileTranslationSetting(project))
            : prev);
        setListProjectOfUser(prev => Array.isArray(prev)
            ? prev.map(project => resetProjectFileTranslationSetting(project))
            : prev);
    };

    const resetProjectKibanaAnalysisSetting = project => {
        if (Utils.isEmptyObject(project)) return project;

        const projectSetting = Utils.convertJSONDataToObject(project.projectSetting) || {};
        if (projectSetting.usingKibanaAnalysis !== true) return project;

        return {
            ...project,
            projectSetting: JSON.stringify({
                ...projectSetting,
                usingKibanaAnalysis: false
            })
        };
    };

    const syncProjectKibanaAnalysisSettingAfterOrgSave = corporationDetailData => {
        const corpSetting = Utils.convertJSONDataToObject(corporationDetailData?.corporationSetting) || {};
        if (corpSetting.usingKibanaAnalysis === Constant.STATUS_SERVICE_PERMISSION.ON) return;

        setProjectInuseDetail(prev => resetProjectKibanaAnalysisSetting(prev));
        setListProjectInCorp(prev => Array.isArray(prev)
            ? prev.map(project => resetProjectKibanaAnalysisSetting(project))
            : prev);
        setListProjectOfUser(prev => Array.isArray(prev)
            ? prev.map(project => resetProjectKibanaAnalysisSetting(project))
            : prev);
    };

    const onSubmitEditCorporation = formData => {
        let isChatGPTModelError = !Utils.isEmptyString(chatGPTModel.error);
        let isKnnValueError = !Utils.isEmptyString(knn.error);
        let isMinScoreError = !Utils.isEmptyString(minScore.error);
        
        let isExistPromptValid = isExistPromptError(modelSettingList, modelSettingAddList);
        let isExistModelError = validateModelError(modelSettingList, modelSettingAddList, chatGPTModelList);
        // Check error all fields
        if (
            !Utils.isEmptyObject(errors) ||
            !Utils.isEmptyString(errorImage) ||
            isChatGPTModelError ||
            isKnnValueError ||
            isMinScoreError ||
            !Utils.isEmptyObject(ipRestrictionError) ||
            isExistPromptValid ||
            isExistModelError
        ) {
            if (isShowPopUpCloseTab) setIsShowPopUpCloseTab(false);
            if (isShowPopUpCancel) setIsShowPopUpCancel(false);
            return;
        }

        //Submit data
        if (isShowPopUpCancel) setIsShowPopUpCancel(false);

        setIsLoading(true);

        const stateObj = {
            croppedImage,
            logoFileName
        };

        //set value ip retriction to formData start
        formData.usingIpAddressRestrict = usingIpAddressRestrict
        formData.ipAddressRange = ipAddressRange
        //set value ip retriction to formData 

        formData.usingMultiAuth = usingMultiAuth;
//p1
        // Validate Duplicate/Required
        let dataValid = updateDuplicateError(modelSettingList, modelSettingAddList);
        if (dataValid?.hasAnyDuplicate || dataValid?.hasAnyBlankModel) {
            setModelSettingList(dataValid.newListModelSetting);
            setModelSettingAddList(dataValid.newListAddModelSetting);
            setIsLoading(false);
            return;
        }

        handleSubmitEditCorporation( 
            props?.API, 
            stateObj, 
            formData, 
            corporationDetail, 
            userDetail?.id, 
            setLincenseKey,
            setLicenseKeyDefault,
            lincenseKey, 
            usingAIAuto,
            usingSDAuto,
            usingTelephoneAgent,
            usingFileTranslation,
            usingKBoard,
            systemPrompt,
            chatGPTModel,
            knn,
            minScore,
            setSystemPromptDefault,
            setChatGPTModelDefault,
            setKnnDefault,
            setMinScoreDefault,
            setSystemPrompt,
            setInputSystemPrompt,
            interatorSystemPrompt,
            setInteratorSystemPrompt,
            setInteratorSystemPromptDefault,
            setInputInteratorSystemPrompt,

            modelSettingList,
            setModelSettingList,
            modelSettingAddList,
            setModelSettingAddList,
            setModelSettingListRoot,
            usingMCPServer,
            kBoardSystemPromptLink,
            usingKibanaAnalysis,
            usingMultiLanguage
        )
            .then(result => {
                if ( result.isEditedSuccess ) {
                    // CR-2026-015: when multilingualSupport toggle changes, prompt reload so the
                    // UI language switches for users whose main language differs from Japanese.
                    setCorporationDetail(result.corporationDetail);
                    syncProjectFileTranslationSettingAfterOrgSave(result.corporationDetail);
                    syncProjectKibanaAnalysisSettingAfterOrgSave(result.corporationDetail);

                    if (result.corporationDetail?.corporationLogo) {
                        setImagePreview(result.corporationDetail?.corporationLogo);
                    }
                    if (!isEqual(result.corporationDetail, corporationDetail)) {
                        enqueueSnackbar(buildSnackbarMessage('COMMSG047'), {
                            variant: 'success',
                            autoHideDuration: 3000
                        });
                        if (isShowPopUpCloseTab) {
                            setIsShowPopUpCloseTab(false)
                            handleCloseTab(
                                props.panelId,
                                props.tabId,
                                panelList,
                                closePanelTab,
                                setIsShowPopUpCloseTab
                            )
                        }
                        if(result.corporationDetail?.limitValue?.usingChatAI != corporationDetail?.limitValue?.usingChatAI && corporationDetail?.limitValue?.usingChatAI == Constant.STATUS_SERVICE_PERMISSION.ON){
                            reloadPanelChatbotSetting({
                                panelType: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
                                id: Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_CHATBOT
                            })
                        }
                    }
                } else {
                        /**
                        * handle error for ip restriction func start
                        */

                        if (result?.isErrorModelSetting) {
                            return;
                        }
                        const errorCode = result?.error?.replace('ApiError==', '');
                        let errorIpRestrictionObject = {};
                        switch (errorCode) {
                            case MessageCode.MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT:
                                errorIpRestrictionObject['ipAddressRange'] = trI18n(
                                    'IP_ADDRESS_FORMAT_WRONG'
                                );
                                break;
                            case MessageCode.MSG_UPDATE_IP_ADDRESS_MAX_EXCCED:
                                errorIpRestrictionObject['ipAddressRange'] = trI18n(
                                    'IP_ADDRESS_MAX_EXCCED'
                                ).replace('{{maxIpAddress}}', '150');
                                break;
                            case MessageCode.MSG_UPDATE_IP_ADDRESS_EMPTY:
                                errorIpRestrictionObject['ipAddressRange'] = trI18n(
                                    'MSG-CM-REQUIRED-INPUT'
                                );
                                break;
                            case MessageCode.MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT_DUPLICATE:
                                errorIpRestrictionObject['ipAddressRange'] = trI18n(
                                    'IP_ADDRESS_DUPLICATE'
                                );
                                break;
                            default:
                        }
                            if (!Utils.isEmptyObject(errorIpRestrictionObject))
                                setIPRestrictionError(errorIpRestrictionObject);
                            /**
                            * handle error for ip restriction func end
                            */
                            if ([result.error, errorCode].includes(Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR)) {
                               setIsOpenModalReloadPage(true);
                           }
                       }
            })
            .finally(() => {
                setCroppedImage(null);
                // reset(formData);
                setIsEdited(false);
                setIsLoading(false);
                if (isShowPopUpCloseTab) setIsShowPopUpCloseTab(false);
                if (isShowPopUpCancel) setIsShowPopUpCancel(false);
            });
    };

    const updateDuplicateError = (listA, listB) => {
        const combined = [...listA, ...listB];

        // Count the number of times a model occurs (chỉ tính nếu có model)
        const modelCount = combined.reduce((acc, item) => {
            if (item.model) {
                acc[item.model] = (acc[item.model] || 0) + 1;
            }
            return acc;
        }, {});

        // Các model bị duplicate
        const duplicateModels = Object.keys(modelCount).filter(model => modelCount[model] > 1);

        let hasAnyDuplicate = duplicateModels.length > 0;
        let hasAnyBlankModel = false;

        const applyError = item => {
            const isModelBlank = !item.model || item.model.trim() === '';
            const isDup = duplicateModels.includes(item.model);

            if (isModelBlank) hasAnyBlankModel = true;

            let error;
            if (isModelBlank) {
                error = 'MSG_AI_MODEL_REQUIRED';
            } else if (isDup) {
                error = 'MSG_AI_MODEL_DUPLICATE';
            }

            return {
                ...item,
                hasDuplicate: isDup,
                isModelBlank,
                error
            };
        };

        return {
            newListModelSetting: listA.map(applyError),
            newListAddModelSetting: listB.map(applyError),
            hasAnyDuplicate,
            hasAnyBlankModel
        };
    };



    const handleChangeInputLincenseKey = (e) => {
        let lincenseKeyValue = e.target.value.trim();
        setIsEdited(true);
        setLincenseKey(prev => ({
            ...prev,
            value: lincenseKeyValue,
            error: ''
        }))
        setValue('lincenseKeyValue', lincenseKeyValue);
    };

    const handleDisableSystemPromptInput = () => {
        return !usingChatAI || !usingAIAuto;
    }

    const isDisableChangeEdit = (model) => {
        let result = (typeof model?.editing === "undefined" || model?.editing == 0);
        return result;
    };

    const renderFieldSystemPrompt = (
        systemPromptData,
        setIsChangeSystemPromptData,
        item,
        fieldKey
    ) => {
        return (
            <div className="prompt-basic-chip-ai-auto org-profile-system-prompt-input prompt-basic-chip-ai-auto-column">
                {!systemPromptData?.value ||
                (systemPromptData?.value && systemPromptData?.error) ? (
                    <>
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 chip-org-profile"
                        variant="outlined"
                        spellCheck={false}
                        autoComplete="seriously-please-don't-autocomplete"
                        type="text"
                        onBlur={async e => {
                            let params = {
                                e: e,
                                API: props?.API,
                                setIsLoading: setIsLoading,
                                systemPromptData: systemPromptData,
                                setIsEdited: setIsEdited,
                                setIsChangeSystemPromptData: setIsChangeSystemPromptData,

                                setModelSettingAddList: setModelSettingList,
                                currentIndex: item.id,
                                fieldKey: fieldKey
                            }
                            
                            await handleOnBlurEditSystemPromptModelSetting(params)
                        }
                           
                        }
                        helperText={''}
                        error={!Utils.isEmptyString(systemPromptData.error)}
                        disabled={handleDisableSystemPromptInput() || isDisableChangeEdit(item)}
                        value={systemPromptData?.linkPrompt}
                        onChange={e => {
                            handleEditTextField(e, item.id, fieldKey, item)
                        }}
                    />
                    {!Utils.isEmptyString(systemPromptData?.error) && (
                        <div>
                            <span className='text-warning-chat-ai text-warning-model'>
                               {trI18n(systemPromptData?.error)}
                            </span>
                        </div>
                    )}
                    </>
                ) : (
                    <Chip
                        label={
                            <OverFlowTooltipWithCustomCss
                                value={systemPromptData?.value}
                                placement={'top'}
                            />
                        }
                        onClick={async () => {
                            if (Utils.isEmptyString(systemPromptData?.value)) return;
                            const idTicket = await Utils.getTicketIdByShareLink(systemPromptData?.linkPrompt);
                            openPromptTicketPanel(
                                setIsLoading,
                                userDetail,
                                idTicket,
                                projectInuseDetail,
                                setIsOpenModalReloadPage,
                                addNewPanel,
                                setIsOpenAccessDeniedPopup
                            );
                        }}
                        // comment for now
                        // onDelete={() => {
                        //     if (handleDisableSystemPromptInput()) return true;
                        //     if (isDisableChangeEdit(item)) return true;
                        //     setModelSettingList(prevList =>
                        //         prevList.map(model => resetModelField(model, item, fieldKey))
                        //     );
                        //     setIsEdited(true);
                        //     setIsChangeSystemPromptData(true);
                        // }}
                        onDelete={isDisableChangeEdit(item) ? null : (e) => handleDeleteModelField(item, fieldKey, setIsChangeSystemPromptData)}
                        disableRipple={handleDisableSystemPromptInput() || isDisableChangeEdit(item)}
                        deleteIcon={isDisableChangeEdit(item) ? null : (
                            <img
                                className={`basic-chip-delete-icon ${
                                    handleDisableSystemPromptInput()
                                        ? 'basic-chip-delete-icon-disable'
                                        : ''
                                }`}
                                src="/assets/image/delete-icon-rounded.svg"
                                alt="delete"
                            />
                        )}
                        className={`basic-chip chip-ai-auto top-4px ${
                            handleDisableSystemPromptInput() ? 'basic-chip-disable' : ''
                        }`}
                        // disabled={handleDisableSystemPromptInput()}
                    />
                )}
            </div>
        );
    };

    const resetModelField = (model, item, fieldKey) => {
        if (model.id !== item.id) return model;
        return {
            ...model,
            [fieldKey]: {
                ...model[fieldKey],
                error: '',
                value: '',
                linkPrompt: ''
            },
            hasChange: true,
        };
    };

    const handleDeleteModelField = (item, fieldKey, setIsChangeSystemPromptData) => {
        if (handleDisableSystemPromptInput()) return;
        if (isDisableChangeEdit(item)) return;

        setModelSettingList(prevList =>
            prevList.map(model => resetModelField(model, item, fieldKey))
        );

        setIsEdited(true);
        setIsChangeSystemPromptData(true);
    };

    const handleEditTextField = (e, id, fieldKey, item) => {
        let inputValue = e.target.value;

        switch (fieldKey) {
            case Constant.MODEL_PROMPT_TYPE.INTERATOR_SYSTEM_PROMPT:
            case Constant.MODEL_PROMPT_TYPE.SYSTEM_PROMPT:
                setModelSettingList(prevList => {
                    const updatedList = prevList.map(model => {
                        if (model.id === id) {
                            return {
                                ...model,
                                [fieldKey]: {
                                    ...model[fieldKey],
                                    linkPrompt: inputValue,
                                },
                                hasChange: true,
                            };
                        }
                        return model; 
                    });
                    return updatedList;
                });
                break;
        
            default:
                return;
        }
    }

    const handlerResetAISetting = async () => {
        setIsShowMsgSettingAI(false);
        setIsLoading(true);
        let versionData = await getProductByIdAPI(props?.API, corporationDetail.versionId);
        let moduleSetting = Utils.convertJSONDataToObject(versionData?.moduleSetting);

        setChatGPTModel(moduleSetting.chatGPTModel || Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
        setKnn(pre => ({...pre, value: moduleSetting.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE, error: ''}));
        setMinScore(pre => ({...pre, value: moduleSetting.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE, error: ''}));
        setIsModelUnsupport(checkModelUnsupport(moduleSetting.chatGPTModel, chatGPTModelList));
        setIsEdited(!checkModelUnsupport(moduleSetting.chatGPTModel, chatGPTModelList));
        setIsLoading(false)
    }

    const handleChangeInputKnn = (e) => {
        let knnValueInput = e.target.value;
        setIsEdited(true);
        setKnn(pre => ({...pre, value: knnValueInput, error: ''}));
    };

    // const handleKeyDownInputKnn = (event) => {
    //     if (['-', '.', 'e'].includes(event.key)) {
    //         event.preventDefault();
    //     }
    // };

    const handleOnBlurInputKnn = (e) => {
        let blurValue = e.target.value

        let rules = [
            {name: 'maxValue', value: 10000},
            {name: 'minValue', value: 1},  
            {name: 'isRequire'},
            {name: 'isNumber'},
        ]
        let fieldKey = 'knn'
        const checkErrorValueInput = validateTextField(rules, blurValue, fieldKey);
        setKnn(pre => ({...pre, value: blurValue.trim(), error: checkErrorValueInput}));
    }


    const handleChangeInputMinScore = (e) => {
        let minScoreInput = e.target.value;
        if (minScoreInput.includes(".")) {
            const [integerPart, decimalPart] = minScoreInput.split(".");

            if (decimalPart && decimalPart.length > 2) {
                return;
            }
        }

        setIsEdited(true);
        setMinScore((pre) => ({ ...pre, value: minScoreInput, error: "" }));
    };

    const isRootCorporationOnChatAI = () => {
        return (
            initData?.corporationData?.limitValue?.chatAI === Constant.STATUS_SERVICE_PERMISSION.ON
        );
    };

    const isRootCorporationOnAIAuto = () => {
        return (
            initData?.corporationData?.limitValue?.aiAuto === Constant.STATUS_SERVICE_PERMISSION.ON
        );
    };

    const isRootCorporationOnSDAuto = () => {
        return (
            initData?.corporationData?.limitValue?.sdAuto === Constant.STATUS_SERVICE_PERMISSION.ON
        );
    };

    const isRootCorporationOnTelephoneAgent = () => {
        return (
            initData?.corporationData?.limitValue?.telephoneAgent === Constant.STATUS_SERVICE_PERMISSION.ON
        );
    };

    const isRootCorporationOnFileTranslation = () => {
        return (
            initData?.corporationData?.limitValue?.fileTranslation === Constant.STATUS_SERVICE_PERMISSION.ON
        );
    };

    const isRootCorporationOnKBoard = () => {
        return (
            initData?.corporationData?.limitValue?.kBoard === Constant.STATUS_SERVICE_PERMISSION.ON
        );
    };

    const renderClusterAIAutoAndSDAuto = () => {
        return (

                <div className="org-profile-wrap-footer-ai-auto">
                    {isRootCorporationOnAIAuto() && (
                        <>
                            <div
                                className={`org-profile-field horizontal-field gap-16 ${
                                    !usingChatAI ? 'org-profile-interator-prompt' : ''
                                }`}
                            >
                                <div className="title-name">
                                    {trI18n('ORG-INFOR-LABEL-AI-AUTO')}
                                </div>

                                <div className="switch-check">
                                    <input
                                        name="aiAuto"
                                        id="ai-auto"
                                        type="checkbox"
                                        disabled={!usingChatAI}
                                        checked={usingAIAuto}
                                        onChange={e => {
                                            let usingAIAutoValue = !usingAIAuto;
                                            setUsingAIAuto(usingAIAutoValue);
                                            setUsingFileTranslation(usingAIAutoValue);
                                            if (!usingAIAutoValue) {
                                                // Telephone Agent depends on AI Auto: it can only be
                                                // used while AI Auto is ON. Turning AI Auto ON keeps
                                                // the current Telephone Agent value untouched.
                                                setUsingTelephoneAgent(false);
                                                setSystemPrompt(systemPromptDefault);
                                                setInputSystemPrompt('');
                                                setInteratorSystemPrompt(
                                                    interatorSystemPromptDefault
                                                );
                                                setInputInteratorSystemPrompt('');
                                                setModelSettingList(modelSettingListRoot);
                                                setModelSettingAddList([]);
                                            }
                                            setIsEdited(true);
                                        }}
                                    />
                                    <label htmlFor="ai-auto"></label>
                                </div>
                            </div>
                             <div className="head-btn">
                                <div className="head-btn-add">
                                    <Button 
                                        className="btn-add-model-setting" 
                                        onClick={e => {
                                            handleAddNew(modelSettingAddList, setModelSettingAddList);
                                            setIsEdited(true);
                                        }}
                                        disabled={handleDisableSystemPromptInput()}
                                    >
                                        <div className="btn-plus-icon">
                                            <img src={
                                                handleDisableSystemPromptInput()
                                                    ? '/assets/image/icon-plus-accordion.svg'
                                                    : '/assets/image/icon-plus-add.svg'
                                                }
                                                alt="" 
                                            />
                                        </div>
                                        <div className="btn-text-add">{trI18n('ORG-INFOR-LABEL-ADD-AI-MODEL-SETTING')}</div>
                                    </Button>
                                </div>
                            </div>

                            {/* model setting list */}
                            <div className="group-setting-model">
                                <div className="model-setting-table">{renderTblModelSettingList()}</div>
                            </div>
                        </>
                    )}

                    <div className="org-profile-field horizontal-field gap-16 org-profile-interator-prompt">
                        <div className="title-name">{trI18n('MSG-AUTO-DELETE-UNSUPPORT-GPTMODEL')}</div>
                    </div>
                    
                    {isRootCorporationOnSDAuto() && (
                        <div
                            className={`org-profile-field horizontal-field gap-16 org-profile-interator-prompt`}
                        >
                            <div className="title-name">{trI18n('ORG-INFOR-LABEL-SD-AUTO')}</div>

                            <div className="switch-check">
                                <input
                                    name="sdAuto"
                                    id="sd-auto"
                                    type="checkbox"
                                    disabled={!usingChatAI}
                                    checked={usingSDAuto}
                                    onChange={e => {
                                        const usingSDAutoValue = !usingSDAuto;
                                        setUsingSDAuto(usingSDAutoValue);
                                        setIsEdited(true);
                                    }}
                                />
                                <label htmlFor="sd-auto">
                                    <span className="field-hidden">
                                        {trI18n('ORG-INFOR-LABEL-SD-AUTO')}
                                    </span>
                                </label>
                            </div>
                        </div>
                    )}
                    {isRootCorporationOnTelephoneAgent() && (
                        <div
                            className={`org-profile-field horizontal-field gap-16 org-profile-interator-prompt`}
                        >
                            <div className="title-name">{trI18n('ORG-INFOR-LABEL-TELEPHONE-AGENT')}</div>

                            <div className="switch-check">
                                <input
                                    name="telephoneAgent"
                                    id="telephone-agent"
                                    type="checkbox"
                                    disabled={!usingChatAI || !isRootCorporationOnAIAuto()}
                                    checked={usingTelephoneAgent}
                                    onChange={e => {
                                        const usingTelephoneAgentValue = !usingTelephoneAgent;
                                        setUsingTelephoneAgent(usingTelephoneAgentValue);
                                        // Telephone Agent depends on AI Auto: turning it ON
                                        // automatically turns AI Auto ON. File Translation follows
                                        // AI Auto only when AI Auto actually flips OFF -> ON; if AI Auto
                                        // is already ON, Telephone Agent and File Translation stay independent.
                                        if (usingTelephoneAgentValue && !usingAIAuto) {
                                            setUsingAIAuto(true);
                                            setUsingFileTranslation(true);
                                        }
                                        setIsEdited(true);
                                    }}
                                />
                                <label htmlFor="telephone-agent">
                                    <span className="field-hidden">
                                        {trI18n('ORG-INFOR-LABEL-TELEPHONE-AGENT')}
                                    </span>
                                </label>
                            </div>
                        </div>
                    )}
                    {isRootCorporationOnAIAuto() && isRootCorporationOnFileTranslation() && (
                        <div
                            className={`org-profile-field horizontal-field gap-16 org-profile-interator-prompt`}
                        >
                            <div className="title-name">{trI18n('ORG-INFOR-LABEL-FILE-TRANSLATION')}</div>

                            <div className="switch-check">
                                <input
                                    name="fileTranslation"
                                    id="file-translation"
                                    type="checkbox"
                                    disabled={!usingChatAI || !usingAIAuto}
                                    checked={usingFileTranslation}
                                    onChange={e => {
                                        const newValue = !usingFileTranslation;
                                        setUsingFileTranslation(newValue);
                                        setIsEdited(true);
                                    }}
                                />
                                <label htmlFor="file-translation">
                                    <span className="field-hidden">
                                        {trI18n('ORG-INFOR-LABEL-FILE-TRANSLATION')}
                                    </span>
                                </label>
                            </div>
                        </div>
                    )}
                    {isRootCorporationOnKBoard() && (
                        <div
                            className={`org-profile-field horizontal-field gap-16 org-profile-interator-prompt`}
                        >
                            <div className="title-name">{trI18n('ORG-INFOR-LABEL-K-BOARD')}</div>

                            <div className="switch-check">
                                <input
                                    name="kBoard"
                                    id="k-board"
                                    type="checkbox"
                                    disabled={!usingChatAI}
                                    checked={usingKBoard}
                                    onChange={e => {
                                        const newValue = !usingKBoard;
                                        setUsingKBoard(newValue);
                                        setIsEdited(true);
                                    }}
                                />
                                <label htmlFor="k-board">
                                    <span className="field-hidden">
                                        {trI18n('ORG-INFOR-LABEL-K-BOARD')}
                                    </span>
                                </label>
                            </div>
                        </div>
                    )}

                    {isRootCorporationOnKBoard() && (
                        <div className="org-profile-field org-profile-system-prompt">
                            <div className="title-name">
                                {trI18n('LABEL-K-BOARD-SYSTEM-PROMPT')}
                            </div>
                            <div className="prompt-basic-chip-ai-auto org-profile-system-prompt-input prompt-basic-chip-ai-auto-column">
                                {(!kBoardSystemPromptLink ||
                                (kBoardSystemPromptLink && errorKBoardSystemPrompt) ||
                                Utils.isEmptyObject(kBoardPromptDetail)) ? (
                                    <>
                                        <TextField
                                            className="form-control-input form-control-wrapInput form-control-hg32 chip-org-profile"
                                            variant="outlined"
                                            spellCheck={false}
                                            autoComplete="seriously-please-don't-autocomplete"
                                            type="text"
                                            disabled={!usingChatAI || !usingKBoard}
                                            value={kBoardSystemPromptLink || ''}
                                            onChange={e => {
                                                setKBoardSystemPromptLink(e.target.value);
                                            }}
                                            onBlur={e =>
                                                handleOnBlurKBoardSystemPrompt(
                                                    e,
                                                    setKBoardSystemPromptLink,
                                                    setKBoardPromptDetail,
                                                    setErrorKBoardSystemPrompt,
                                                    setIsLoading,
                                                    setIsEdited
                                                )
                                            }
                                            helperText={''}
                                            error={!Utils.isEmptyString(errorKBoardSystemPrompt)}
                                        />
                                        {!Utils.isEmptyString(errorKBoardSystemPrompt) && (
                                            <div>
                                                <span className="text-warning-chat-ai text-warning-model">
                                                    {trI18n(errorKBoardSystemPrompt)}
                                                </span>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <Chip
                                        style={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}
                                        label={
                                            <OverflowTooltipContent
                                                text={
                                                    Utils.convertJSONDataToObject(kBoardPromptDetail?.outline)?.jp
                                                }
                                                style={{ fontWeight: 500, fontSize: '14px', color: '#2D72D2' }}
                                            />
                                        }
                                        onClick={() => {
                                            if (Utils.isEmptyObject(kBoardPromptDetail)) return;
                                            openPromptTicketPanel(
                                                setIsLoading,
                                                userDetail,
                                                kBoardPromptDetail.id,
                                                projectInuseDetail,
                                                setIsOpenModalReloadPage,
                                                addNewPanel,
                                                setIsOpenAccessDeniedPopup
                                            );
                                        }}
                                        onDelete={
                                            !usingChatAI || !usingKBoard
                                                ? null
                                                : () =>
                                                      handleRemoveKBoardSystemPrompt(
                                                          setKBoardSystemPromptLink,
                                                          setKBoardPromptDetail,
                                                          setErrorKBoardSystemPrompt,
                                                          setIsEdited
                                                      )
                                        }
                                        disableRipple={!usingChatAI || !usingKBoard}
                                        deleteIcon={
                                            !usingChatAI || !usingKBoard ? null : (
                                                <img
                                                    className="basic-chip-delete-icon"
                                                    src="/assets/image/delete-icon-rounded.svg"
                                                    alt="delete"
                                                />
                                            )
                                        }
                                        className={`basic-chip chip-ai-auto top-4px ${
                                            !usingChatAI || !usingKBoard ? 'basic-chip-disable' : ''
                                        }`}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                    {isShowSettingMCPServer() && (
                        <div
                            className={`org-profile-field horizontal-field gap-16 org-profile-interator-prompt usingMCP`}
                        >
                            <div className="title-name">
                                {trI18n('ORG-INFOR-LABEL-USING-MCP-SERVER')}
                            </div>
                            <div className="switch-check">
                                <input
                                    name="usingMCPServer"
                                    id="usingMCPServer"
                                    type="checkbox"
                                    disabled={!usingChatAI}
                                    checked={usingMCPServer}
                                    onChange={e => {
                                        let usingMCPServerValue = !usingMCPServer;
                                        setUsingMCPServer(usingMCPServerValue);
                                        setIsEdited(true);
                                    }}
                                />
                                <label htmlFor="usingMCPServer" aria-label="Using MCP Server"></label>
                            </div>
                        </div>
                    )}
                </div>

        );
    };
    

    const handleOnBlurInputMinScore = (e) => {
        let blurValue = e.target.value

        let rules = [
            {name: 'maxValue', value: 1},
            {name: 'minValue', value: 0},
            {name: 'isRequire'},
            {name: 'isDecimal'},
        ]
        let fieldKey = 'minScore'
        const checkErrorValueInput = validateTextField(rules, blurValue, fieldKey);
        setMinScore(pre => ({...pre, value: blurValue.trim(), error: checkErrorValueInput}));
    }

    // render tbl model setting list
    const renderTblModelSettingList = () => {
        let listItems = modelSettingList.map((item, i) => {
            const isLastRow = i === modelSettingList.length - 1;
            return (
                <TableRow key={item.id} className={`table-row-top`}>
                    <TableCell className={`table-row-top ${isLastRow ? 'last-row-no-border-bottom' : ''}`}>
                        {renderModelList(item, i)}
                    </TableCell>
                    <TableCell className={`table-row-top ${isLastRow ? 'last-row-no-border-bottom' : ''}`}>
                        {
                            renderFieldSystemPrompt(
                                item.systemPrompt,
                                setIsChangeSystemPrompt,
                                item,
                                Constant.MODEL_PROMPT_TYPE.SYSTEM_PROMPT
                            )
                        }
                    </TableCell>
                    {/* <TableCell className={`table-row-top ${isLastRow ? 'last-row-no-border-bottom' : ''}`}>
                        {
                            renderFieldSystemPrompt(
                                item.interatorSystemPrompt,
                                setIsChangeInteratorSystemPrompt,
                                item,
                                Constant.MODEL_PROMPT_TYPE.INTERATOR_SYSTEM_PROMPT
                            )
                        }
                    </TableCell> */}
                    {/* edit - delete model setting */}
                    <TableCell className={`table-row-top ${isLastRow ? 'last-row-no-border-bottom' : ''}`}>
                        <div className={`editModelSettingGroupBtn ${handleDisableSystemPromptInput()? ' groupBtnEditModelStting-disable': ''}`}>
                            <div className={`groupBtnEditModelStting`}>
                                <IconButton
                                    className="btn-edit-model-setting"
                                    disabled={handleDisableSystemPromptInput()}
                                    onClick={() => {
                                            let argParams = {
                                                modelSettingList,
                                                setModelSettingList,
                                                setIsEdited
                                            }
                                            editModelSetting(i, item, argParams);
                                        }
                                    }
                                >
                                    <img src="/assets/image/edit-icon.svg" alt="" />
                                </IconButton>
                            </div>
                            
                            <div className="groupBtnEditModelStting">
                                <IconButton
                                    className="btn-edit-model-setting"
                                    disabled={handleDisableSystemPromptInput()}
                                    onClick={() => {
                                            let dataDelete = {
                                                model: item,
                                                modelSettingAddList,
                                                modelSettingList,
                                                setModelSettingAddList,
                                                setModelSettingList,
                                                setIsEdit: setIsEdited
                                            }
                                            onDeleteModelSetting(dataDelete);
                                        }
                                    }
                                >
                                    <img src="/assets/image/delete-icon.svg" alt="" />
                                </IconButton>
                            </div>
                        </div>
                    </TableCell>
                </TableRow>
            );
        });

        let tbl = (
            <div className="table-tbl table-tbl--account">
                <Table data-cy="system-model-setting-list-table" style={{borderCollapse: 'separate', borderSpacing: 0}}>
                    <TableHead>
                        <TableRow>
                            <TableCell className='model-title-color'>
                                {trI18n('ORG-INFOR-LABEL-CHATGPT-MODEL')}
                            </TableCell>
                            <TableCell className='model-title-color'>
                                {tr(ProductManagementConstant.TEXTBOX_SETTING_SYSTEM_PROMPT)}
                            </TableCell>
                            <TableCell className='groupBtnRestoreEditDelete'></TableCell>
                        </TableRow>
                    </TableHead>
                    {/* add model setting */}
                    <TableBody>{renderFormAddModelSetting()}</TableBody>
                    <TableBody>{listItems}</TableBody>
                </Table>
            </div>
        );
        return tbl;
    };

    // render form add new model setting
    const renderFormAddModelSetting = () => {
        let listItemsAdd = modelSettingAddList.map((item, i) => (
            <AddModelSettingRow
                key={item.id || uuidv4()}
                currentAddList={modelSettingAddList}
                modelSettingList={modelSettingList}
                currentIndex={item.id}

                usingChatAI={usingChatAI}
                usingAIAuto={usingAIAuto}
                setIsLoading={setIsLoading}
                setIsEdited={setIsEdited}
                setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                addNewPanel={addNewPanel}
                chatGPTModelList={chatGPTModelList}
                isModelUnsupport={isModelUnsupport}
                setIsModelUnsupport={setIsModelUnsupport}

                onDeleteModelSetting={() => {
                    let dataDelete = {
                        model: item,
                        modelSettingAddList,
                        modelSettingList,
                        setModelSettingAddList,
                        setModelSettingList,
                        setIsEdit: setIsEdited
                    }
                    onDeleteAddModelSetting(dataDelete)
                }}

                modelSettingDetail={item}
                setModelSettingAddList={setModelSettingAddList}
                setModelSettingList={setModelSettingList}
                setIsOpenAccessDeniedPopup={setIsOpenAccessDeniedPopup}
            />
        ));

        return listItemsAdd;
    };

    // render name model setting
    const renderModelList = (item, index) => {
        const modelErrorMessage = [
            {
                condition: checkModelUnsupport(item?.model, chatGPTModelList),
                message: trI18n('MSG-AI-UNSUPPORTED-MODEL').replace(Constant.MODEL_NAME_PLACEHOLDER, item.model),
            },
            {
                condition: item.hasDuplicate,
                message: trI18n('MSG_AI_MODEL_DUPLICATE'),
            },
        ].find(err => err.condition)?.message;
        return (
            <>
                <TextField
                    className="form-control form-control--wrap form-control--hg40 width-70 model-setting-name"
                    select
                    variant="outlined"
                    name="selectedChatGPTModel"
                    value={`${item.model}`}
                    defaultValue={`${item.model}`}
                    SelectProps={{
                        value: `${item.model}`,
                        MenuProps: {
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null,
                            className: 'selectDrop'
                        }
                    }}
                    disabled={handleDisableSystemPromptInput() || isDisableChangeEdit(item)}
                    error={modelErrorMessage}
                    onChange={e => {
                        let  dataChange = {
                                itemId: item.id,
                                newModel: e.target.value,
                                modelSettingAddList,
                                setModelSettingAddList,
                                modelSettingList,
                                setModelSettingList,
                                chatGPTModelList,
                                setIsEdit: setIsEdited
                            };
                            handleModelChange(dataChange)
                    }}
                >
                    {chatGPTModelList?.map(chatGPT => {
                        return (
                            <MenuItem
                                className={
                                    chatGPT?.status ===
                                        Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT &&
                                    'd-hidden'
                                }
                                key={`chatGPT-${chatGPT.id}`}
                                value={chatGPT.id}
                            >
                                <OverFlowTooltipWithTabsMui
                                    className={`className-${chatGPT.id}`}
                                    value={chatGPT.id}
                                >
                                    {chatGPT.id}
                                </OverFlowTooltipWithTabsMui>
                            </MenuItem>
                        );
                    })}
                </TextField>
                {modelErrorMessage && (
                    <div>
                        <span className='text-warning-chat-ai text-warning-model'>
                            {modelErrorMessage}
                        </span>
                    </div>
                )}
            </>
        );
    };

    const isShowSettingMCPServer = () => {
        let isCorpPremium = corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM;
        let limitValue = corporationDetail?.limitValue;
        let isRootOnMCPServer = limitValue?.mcpServer === Constant.STATUS_SERVICE_PERMISSION.ON;

        return isCorpPremium && isRootOnMCPServer;
    }

    const isShowKibanaAnalysis = () => {
        return corporationDetail?.limitValue?.logAnalysis === Constant.STATUS_SERVICE_PERMISSION.ON;
    };

    return (
        <div className="org-profile-wrap">
            <LoadingPanel isLoading={isLoading} />
            {!Utils.isEmptyObject(initData) ? (
                <>
                    <FormProvider {...methods}>
                        <div className="org-profile-wrap-header">
                            <div className="org-profile-btn">
                                <Button
                                    className="btn-light btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    disabled={!isEdited}
                                    onClick={() => handleCancelTab( isEdited, setIsShowPopUpCancel, errors, errorImage )}
                                >
                                    {trI18n('COMBTN001')}
                                </Button>
                            </div>
                            <div className="org-profile-btn">
                                <Button
                                    className="btn-submit btn-primary btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    disabled={isDisableSubmitBtn()}
                                    onClick={handleSubmit(onSubmitEditCorporation)}
                                >
                                    {trI18n('COMBTN011')}
                                </Button>
                            </div>
                        </div>

                        <div className="org-profile-wrap-body">
                            <div
                                className="org-profile-wrap-title"
                                data-cy="org-profile-header-title"
                            >
                                {trI18n('ORG-INFOR-LABEL-TITLE-ORG-INFOR')}
                            </div>

                            {/* LOGO IMAGE */}
                            <div className="title-logo">{trI18n('ORG-INFOR-LABEL-ORG-LOGO')}</div>
                            <div className="logo-wrap">
                                <div className="logo">
                                    <img
                                        src={imagePreview}
                                        alt=""
                                        onError={e => (e.target.src = '/assets/image/logo.svg')}
                                    />
                                </div>
                                <div className="logo-name">
                                    <div className="logo-filename">{logoFileName}</div>
                                    <input
                                        onChange={e =>
                                            onLogoFileChange(
                                                e,
                                                setLogoFileName,
                                                setInputImage,
                                                setOpenCrop
                                            )
                                        }
                                        accept="image/*"
                                        className="updateFile"
                                        id="contained-button-file-organization"
                                        multiple
                                        type="file"
                                    />
                                    <label htmlFor="contained-button-file-organization">
                                        <div className="upload-logo">
                                            {trI18n('ORG-INFOR-LABEL-SELECT-FILE')}
                                        </div>
                                    </label>
                                    {errorImage && (
                                        <div className="imageError">{trI18n('USER01MSG007')}</div>
                                    )}
                                </div>
                            </div>

                            {/* ORG-NAME */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {trI18n('ORG-INFOR-LABEL-ORG-NAME')}
                                    <span className="required">*</span>
                                </div>
                                <FormInput
                                    defaultValue={
                                        initData.corporationData.name
                                            ? initData.corporationData.name
                                            : ''
                                    }
                                    required={true}
                                    errorlist={errors}
                                    name="corporationName"
                                    className="input-corp-name form-control-wrapInput form-control-hg40"
                                    variant="outlined"
                                    inputProps={{
                                        'data-cy': 'org-profile-input-corp-name',
                                        readOnly: !Utils.isAdminUser(userDetail),
                                        onChange: e => {
                                            setValue('corporationName', e.target.value.trim());
                                            clearErrors('corporationName');
                                            setIsEdited(true);
                                        },
                                        onBlur: e => {
                                            let blurValue = e.target.value.trim();
                                            if (Utils.isEmptyString(blurValue)) {
                                                setError(
                                                    'corporationName',
                                                    {
                                                        type: 'manual',
                                                        message: trI18n('COMMSG014')
                                                    },
                                                    { shouldFocus: false }
                                                );
                                            } else {
                                                setValue('corporationName', blurValue);
                                                clearErrors('corporationName');
                                            }
                                        }
                                    }}
                                />
                            </div>

                            {/* ADMIN-LIST */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {trI18n('ORG-INFOR-LABEL-ADMIN-NAME')}
                                    <span className="required">*</span>
                                </div>

                                <TextField
                                    className="form-control form-control--wrap form-control--hg40"
                                    select
                                    disabled={!Utils.isAdminUser(userDetail)}
                                    variant="outlined"
                                    name="selectedAdmin"
                                    value={`${adminName}`}
                                    defaultValue={`${adminName}`}
                                    SelectProps={{
                                        value: `${adminName}`,
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    onChange={e => {
                                        const selectedAdmin = adminList.find(
                                            admin => admin.fullName === e.target.value
                                        );
                                        setAdminName(e.target.value);
                                        setValue('selectedAdmin', selectedAdmin);
                                        setAdminMail(selectedAdmin.mail);
                                        setValue('mailAdmin', selectedAdmin.mail);
                                        setIsEdited(true);
                                    }}
                                >
                                    {adminList.map(admin => {
                                        return (
                                            <MenuItem
                                                key={`admin-${admin.id}`}
                                                value={admin.fullName}
                                            >
                                                <OverFlowTooltipWithTabsMui
                                                    className={`className-${admin.id}`}
                                                    value={admin.fullName}
                                                >
                                                    {admin.fullName}
                                                </OverFlowTooltipWithTabsMui>
                                            </MenuItem>
                                        );
                                    })}
                                </TextField>
                            </div>

                            {/* ADMIN-MAIL */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {trI18n('ORG-INFOR-LABEL-ADMIN-MAIL')}
                                </div>
                                <TextField
                                    name="mailAdmin"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                    variant="outlined"
                                    autoComplete="off"
                                    value={adminMail}
                                    disabled={true}
                                />
                            </div>

                            {/* PHONE */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {trI18n('LABEL-PHONE-NUMBER')}
                                    {!isAdminGuest && <span className="required">*</span>}
                                </div>
                                <PhoneInput
                                    country={'jp'}
                                    disabled={!Utils.isAdminUser(userDetail)}
                                    value={corporationPhone || '+81'}
                                    onChange={onChangePhoneNumber}
                                    onBlur={onBlurPhoneInput}
                                    countryCodeEditable={false}
                                    autoFormat={false}
                                    placeholder={trI18n('COMMSG067').replace(
                                        '{{item}}',
                                        tr('電話番号')
                                    )}
                                    name="telNumberCorporation"
                                    inputProps={{
                                        name: 'telNumberCorporation',
                                        className: 'form-control edit-org-input',
                                        variant: 'outlined',
                                        size: 'small'
                                    }}
                                    data-cy="create-org-input-corp-phone"
                                />
                                <div style={{ marginTop: '5px' }}>
                                    <ErrorHelper
                                        isShowError={
                                            errors && errors.hasOwnProperty('telNumberCorporation')
                                        }
                                        textError={errors['telNumberCorporation']?.message}
                                        customCss={{
                                            customText: {
                                                fontWeight: 700,
                                                fontSize: '0.88rem',
                                                lineHeight: '1.4',
                                                opacity: '0.8'
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            {/* SUB-DOMAIN */}
                            <div className="org-profile-field">
                                <div className="title-name">
                                    {trI18n('ORG-INFOR-LABEL-SUBDOMAIN')}
                                </div>
                                <TextField
                                    name="subDomainCorportion"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input"
                                    variant="outlined"
                                    autoComplete="off"
                                    disabled={true}
                                    value={subDomain}
                                />
                            </div>
                        </div>

                        {isRootCorporationOnChatAI() && (
                            <div className="org-profile-wrap-footer-ai">
                                <div
                                    className="org-profile-wrap-title"
                                    data-cy="org-profile-header-title"
                                >
                                    {trI18n('ORG-INFOR-LABEL-AI-SETTING')}
                                </div>


                                {/* AI-chat */}
                                <div className="org-profile-field horizontal-field">
                                    <div className="title-name setting-ai-function">
                                        {trI18n('ORG-INFOR-LABEL-USE-AI')}
                                    </div>

                                    <div className="switch-check setting-ai-function">
                                        <input
                                            name="chatAI"
                                            id="ai-chat-id"
                                            type="checkbox"
                                            disabled={!enableOnChangeVectorData}
                                            checked={usingChatAI}
                                            onChange={e => {
                                                let usingChatAIValue = !usingChatAI;
                                                setUsingChatAI(usingChatAIValue);
                                                setValue(
                                                    'usingChatAI',
                                                    usingChatAIValue
                                                        ? Constant.STATUS_SERVICE_PERMISSION.ON
                                                        : Constant.STATUS_SERVICE_PERMISSION.OFF
                                                );
                                                setIsEdited(true);
                                                setLincenseKey(prev => ({
                                                    ...prev,
                                                    error: ''
                                                }));
                                                if (!usingChatAIValue) {
                                                    setLincenseKey(prev => ({
                                                        ...prev,
                                                        value: licenseKeyDefault,
                                                        error: ''
                                                    }));
                                                    setSystemPrompt(systemPromptDefault);
                                                    setInteratorSystemPrompt(interatorSystemPromptDefault);
                                                    setChatGPTModel(chatGPTModelDefault);
                                                    setIsModelUnsupport(checkModelUnsupport(chatGPTModelDefault, chatGPTModelList));
                                                    setKnn(knnDefault);
                                                    setMinScore(minScoreDefault);
                                                    setUsingAIAuto(false);
                                                    setUsingSDAuto(false);
                                                    setUsingTelephoneAgent(false);
                                                    setUsingFileTranslation(false);
                                                    setUsingKBoard(false);
                                                    setUsingMCPServer(false);
                                                    setInputSystemPrompt('');
                                                    setInputInteratorSystemPrompt('');
                                                    
                                                    setModelSettingList(modelSettingListRoot);
                                                    setModelSettingAddList([]);
                                                }
                                            }}
                                        />
                                        <label htmlFor="ai-chat-id"></label>
                                    </div>

                                    {(corporationDetail?.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON) && (
                                        <>
                                            {corporationDetail?.limitValue?.vectorTicketDataStatus ===
                                            Constant.VECTOR_DATA_STATUS.DONE ? (
                                                <div className='color-vector-done'>{tr('AI用ベクトル準備済')}</div>
                                            ) : (
                                                <div className='color-vector-inprogress'>{tr('AI用ベクトル作成中')}</div>
                                            )}
                                        </>
                                    )}
                                </div>

                                {initData.corporationData.limitValue.chatAI === Constant.STATUS_SERVICE_PERMISSION.ON && (
                                    <>
                                        <div className={`org-profile-field`}>
                                            <div className="title-name">
                                                {trI18n('ORG-INFOR-LABEL-LICENSE-AI')}
                                            </div>
                                            <input
                                                name="lincenseKey"
                                                type='text'
                                                className={`private-lincenseKey-input ${!Utils.isEmptyString(lincenseKey.error) && 'error'}`}
                                                value={lincenseKey.value}
                                                disabled={!usingChatAI}
                                                onChange={e => handleChangeInputLincenseKey(e)}
                                                onWheel={e => e.target.blur()}
                                                onBlur={e => {
                                                    const value = e.target.value;
                                                    if (
                                                        !lincenseKeyPermission &&
                                                        usingChatAI &&
                                                        value.length == 0
                                                    ) {
                                                        setLincenseKey(prev => ({
                                                            ...prev,
                                                            error: trI18n('MSG_AI_LICENSE_KEY_REQUIRED')
                                                        }))
                                                    }
                                                }}
                                            />
                                        </div>
                                        
                                        {!lincenseKeyPermission && (
                                            <div className='lincenseKey-instruction'>
                                                <img className='icon-instruction-chat-ai' src="/assets/image/icon-instruction-chat-ai.svg" alt="icon" />
                                                <span className='text-instruction-chat-ai'>
                                                    {trI18n('LABEL-AI-LICENSE-KEY-SETTING-INSTRUCTION')}
                                                </span>
                                            </div>
                                        )}
                                        {!Utils.isEmptyString(lincenseKey.error) && (
                                            <div className='lincenseKey-instruction'>
                                                <span className='text-warning-chat-ai'>
                                                    {lincenseKey.error}
                                                </span>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}

                        {usingChatAI && (
                        <div className="org-setting-ai">
                            {/* TITLE SETTING ADVANCED */}
                            <div className='org-setting-ai-chatgpt-header'>
                                <div className='title-name'>
                                    <div className='label-title'>
                                        <label className='label-text-advanced'>
                                            {trI18n('ORG-INFOR-LABEL-SETTING-ADVANCED')}
                                        </label>
                                    </div>
                                    <div>
                                        <label className='label-text-advanced'>
                                            {trI18n('ORG-INFOR-TEXT-SETTING-ADVANCED')}
                                        </label>  
                                    </div>
                                </div>
                            </div>
                            
                            {/* CHATGPT_MODEL */}
                            <div className="org-setting-ai-chatgpt">
                                <div className="org-setting-ai-chatgpt-header">
                                    <div className="title-name">
                                    <Tooltip title={trI18n('LABEL-SETTING-CHATGPT-MODEL')} arrow= {false} placement = "top-start">
                                        <div>
                                            <label
                                                className="label-search-pdf"
                                                htmlFor={`checkbox-include-search-synonym-helpdesk-list`}
                                            >
                                                {trI18n('ORG-INFOR-LABEL-CHATGPT-MODEL')}
                                            </label>
                                            <span className="required">*</span>
                                        </div>
                                    </Tooltip>
                                    </div>
                                    <div className="org-setting-ai-chatgpt-header-right" onClick={() => setIsShowMsgSettingAI(true)}>
                                        <img className='title-name' src="/assets/image/icon-reset.svg" alt="reset"/>
                                        <div className="title-name">{trI18n('ORG-INFOR-LABEL-RESET')}</div>
                                    </div>
                                </div>
                               
                                <TextField
                                    className="form-control form-control--wrap form-control--hg40 width-70"
                                    select
                                    variant="outlined"
                                    name="selectedChatGPTModel"
                                    value={`${chatGPTModel}`}
                                    defaultValue={`${chatGPTModel}`}
                                    SelectProps={{
                                        value: `${chatGPTModel}`,
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    error={isModelUnsupport}
                                    onChange={e => {
                                        setChatGPTModel(e.target.value);
                                        setIsModelUnsupport(checkModelUnsupport(e.target.value, chatGPTModelList));
                                        setIsEdited(!checkModelUnsupport(e.target.value, chatGPTModelList));
                                    }}
                                >
                                    {chatGPTModelList?.map(chatGPT => {
                                        return (
                                            <MenuItem
                                                className={
                                                    chatGPT?.status ===
                                                        Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT &&
                                                    'd-hidden'
                                                }
                                                key={`chatGPT-${chatGPT.id}`}
                                                value={chatGPT.id}
                                            >
                                                <OverFlowTooltipWithTabsMui
                                                    className={`className-${chatGPT.id}`}
                                                    value={chatGPT.id}
                                                >
                                                    {chatGPT.id}
                                                </OverFlowTooltipWithTabsMui>
                                            </MenuItem>
                                        );
                                    })}
                                </TextField>
                                {isModelUnsupport && (
                                    <div>
                                        <span className='text-warning-chat-ai text-warning-model'>
                                            {trI18n('MSG-AI-UNSUPPORTED-MODEL').replace(Constant.MODEL_NAME_PLACEHOLDER,chatGPTModel)}
                                        </span>
                                    </div>
                                )}
                            </div>
                            
                            {/* KNN_VALUE */}

                            <div className="org-setting-ai-knn">
                                <div className="title-name horizontal-field">
                                    <Tooltip title={trI18n('LABEL-SETTING-KNN')} arrow= {false} placement = "top-start">
                                        <div>
                                            <label
                                                className="label-search-pdf"
                                                htmlFor={`checkbox-include-search-synonym-helpdesk-list`}
                                            >
                                                {trI18n('ORG-INFOR-LABEL-KNN-VALUE')}
                                            </label>
                                            <span className="required">*</span>
                                        </div>
                                    </Tooltip>
                                </div>
                                <TextField
                                    name="knnValue"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input width-70"
                                    variant="outlined"
                                    autoComplete="off"
                                    value={knn.value}
                                    onChange={e => handleChangeInputKnn(e)}
                                    onBlur={e => handleOnBlurInputKnn(e)}
                                    // onKeyDown={e => handleKeyDownInputKnn(e)}
                                    type='text'
                                    helperText={tr(knn.error)}
                                    error={!Utils.isEmptyString(knn.error)}
                                />
                            </div>

                            {/* MIN_SCORE */}

                            <div className="org-setting-ai-minscore">
                                <div className="title-name horizontal-field">
                                <Tooltip title={trI18n('LABEL-SETTING-MIN-SCORE')} arrow= {false} placement = "top-start">
                                        <div>
                                            <label
                                                className="label-search-pdf"
                                                htmlFor={`checkbox-include-search-synonym-helpdesk-list`}
                                            >
                                                {trI18n('ORG-INFOR-LABEL-MIN-SCORE')}
                                            </label>
                                            <span className="required">*</span>
                                        </div>
                                    </Tooltip>
                                </div>

                                <TextField
                                    name="minScore"
                                    className="form-control form-control--wrap form-control--hg40 edit-org-input width-70"
                                    variant="outlined"
                                    autoComplete="off"
                                    value={minScore.value}
                                    onChange={e => handleChangeInputMinScore(e)}
                                    onBlur={e => handleOnBlurInputMinScore(e)}
                                    // onKeyDown={e => handleKeyDownInputMinScore(e)}
                                    type='text'
                                    helperText={tr(minScore.error)}
                                    error={!Utils.isEmptyString(minScore.error)}
                                />
                                
                            </div>
                        </div>
                        )}
                        {(isRootCorporationOnAIAuto() || isRootCorporationOnSDAuto() || isRootCorporationOnTelephoneAgent() || isRootCorporationOnKBoard()) &&
                            renderClusterAIAutoAndSDAuto()}

                        {initData?.corporationData?.limitValue?.multiLanguage ===
                            Constant.STATUS_SERVICE_PERMISSION.ON && (
                            <div className="org-profile-wrap-footer">
                                <div style={{ display: 'flex', gap: 16 }}>
                                    <div className="org-profile-wrap-title" style={{ marginBottom: 0 }}>
                                        {trI18n('LABEL_FUNCTION_MULTILINGUAL_SUPPORT')}
                                    </div>
                                    <div className="switch-check setting-ai-function">
                                        <input
                                            name="usingMultiLanguage"
                                            id="setting-multiLanguage-switch-id"
                                            type="checkbox"
                                            checked={usingMultiLanguage}
                                            onChange={() => {
                                                setUsingMultiLanguage(prev => !prev);
                                                setIsEdited(true);
                                            }}
                                        />
                                        <label
                                            htmlFor="setting-multiLanguage-switch-id"
                                            style={{ color: 'transparent' }}
                                        >
                                            .
                                        </label>
                                    </div>
                                </div>
                            </div>
                        )}

                        {isShowKibanaAnalysis() && (
                            <div className="org-profile-wrap-footer">
                                <div
                                    className="org-profile-wrap-title"
                                    data-cy="org-profile-header-kibana-analysis"
                                >
                                    {trI18n('ORG-INFOR-LABEL-KIBANA-ANALYSIS')}
                                </div>
                                <div className="horizontal-field">
                                    <div className="title-name setting-ai-function">
                                        {trI18n('ORG-INFOR-LABEL-KIBANA-ANALYSIS-TOGGLE')}
                                    </div>
                                    <div className="switch-check setting-ai-function">
                                        <input
                                            name="usingKibanaAnalysis"
                                            id="usingKibanaAnalysis"
                                            type="checkbox"
                                            checked={usingKibanaAnalysis}
                                            onChange={e => {
                                                setUsingKibanaAnalysis(!usingKibanaAnalysis);
                                                setIsEdited(true);
                                            }}
                                        />
                                        <label htmlFor="usingKibanaAnalysis" aria-label="Using Kibana Analysis"></label>
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        {initData?.corporationData?.limitValue?.ipRestriction === Constant.STATUS_SERVICE_PERMISSION.ON && (
                            <IPRestrictionSetting
                                //state
                                usingIpAddressRestrict={usingIpAddressRestrict}
                                error={ipRestrictionError}
                                ipAddressRange={ipAddressRange}
                                //state
                                setError={setIPRestrictionError}
                                setIsEdited={setIsEdited}
                                setUsingIpAddressRestrict={setUsingIpAddressRestrict}
                                setIpAddressRange={setIpAddressRange}
                                //event
                                onChangeUsingIpAddressRestrict={onChangeUsingIpAddressRestrict}
                                onChangeIpAddressRange={onChangeIpAddressRange}
                                changeIpAddressRange={changeIpAddressRange}
                            />
                        )}

                        {initData?.corporationData?.limitValue?.multiAuth === 
                            Constant.STATUS_SERVICE_PERMISSION.ON && (
                            <MultiAuthSetting
                                usingMultiAuth={usingMultiAuth}
                                setIsEdited={setIsEdited}
                                setUsingMultiAuth={setUsingMultiAuth}
                                onChangeUsingMultiAuth={() => {
                                    setUsingMultiAuth(prev => !prev);
                                    setIsEdited(true);
                                }}
                            />
                        )}
                        
                    </FormProvider>

                    {/* dialog select img  */}
                    <CropImage
                        openCrop={openCrop}
                        setOpenCrop={setOpenCrop}
                        aspect={aspect}
                        cropShape={cropShape}
                        inputImage={inputImage}
                        setInputImage={setInputImage}
                        setCroppedImage={setCroppedImage}
                        setErrorImage={setErrorImage}
                        setImagePreview={setImagePreview}
                        imageName={logoFileName}
                        setImageName={setLogoFileName}
                        oldImageName={oldLogoFileName}
                        setOldImageName={setOldLogoFileName}
                        setIsEdited={setIsEdited}
                    />

                    {/* dialog confirm close tab or cancel  */}
                    <ConfirmDialog
                        isOpen={isShowPopUpCloseTab || isShowPopUpCancel}
                        msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                        okCallBack={handleSubmit(onSubmitEditCorporation)}
                        closeCallBack={async () => {
                            if (isShowPopUpCloseTab) {
                                handleCloseTab(
                                    props.panelId,
                                    props.tabId,
                                    panelList,
                                    closePanelTab,
                                    setIsShowPopUpCloseTab
                                );
                            }
                            if (isShowPopUpCancel) {
                                setIsShowPopUpCancel(false);
                                getInitCorporationAndListUser(getInitCorpArgs)
                                    .then(response => {
                                        if (response) {
                                            clearErrors();
                                            setIPRestrictionError({})
                                            setIsEdited(false);
                                            setIsLoading(false);
                                            const corporationSetting = Utils.convertJSONDataToObject(
                                                corporationDetail?.corporationSetting
                                            );
                                            setUsingIpAddressRestrict(corporationSetting?.usingIpAddressRestrict)
                                            setIpAddressRange(corporationSetting?.ipAddressRange || "");
                                        }
                                    })
                                    .catch(error => {
                                        clearErrors();
                                        setIsEdited(false);
                                        setIsLoading(false);
                                        console.log('get initCorp error >>>', error);
                                    });
                            }
                        }}
                        cancelCallBack={() => {
                            if (isShowPopUpCloseTab) setIsShowPopUpCloseTab(false);
                            if (isShowPopUpCancel) setIsShowPopUpCancel(false);
                        }}
                        textSubmit={trI18n('COMBTN002')}
                        textClose={trI18n('COMBTN007')}
                        isShowClassnameButton={false}
                    />

                    {/* dialog reload */}
                    <DataChangePleaseReloadModal
                        isOpen={isOpenModalReloadPage}
                        setIsOpen={setIsOpenModalReloadPage}
                    />
                    <ConfirmDialog
                        isOpen={isShowMsgSettingAI}
                        msgConfirm={trI18n('MSG-CONFIRM-RESET-SETTING-AI')}
                        closeCallBack={() => {
                            setIsShowMsgSettingAI(false);
                        }}
                        okCallBack={handlerResetAISetting}
                        textSubmit={trI18n('CM-BUTTON-OK')}
                        textClose={trI18n('CM-BUTTON-CANCEL')}
                    />
                    <ConfirmDialog
                        isOpen={isOpenAccessDeniedPopup}
                        msgConfirm={trI18n('KNOWDEMSG005')}
                        okCallBack={() => window.location.reload()}
                    />
                </>
            ) : (
                <></>
            )}
        </div>
    );
}
